import React from "react"

import styled from "styled-components"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faFacebookSquare, faTwitter, faInstagram } from "@fortawesome/free-brands-svg-icons"

import linkWorm from "./styles/linkWorm"

export default () => {
  return (
    <SocialMedia>
      <ul>
        <li>
          <a href="https://www.facebook.com/TryHardJapan/" target="_blank" rel="noopener noreferrer">
            <Icon icon={faFacebookSquare} />
            Facebook
          </a>
        </li>
        <li>
          <a href="https://twitter.com/TryHard_jp" target="_blank" rel="noopener noreferrer">
            <Icon icon={faTwitter} />
            Twitter
          </a>
        </li>
        <li>
          <a href="https://www.instagram.com/tryhard_japan_official/" target="_blank" rel="noopener noreferrer">
            <Icon icon={faInstagram} />
            Instagram
          </a>
        </li>
      </ul>
    </SocialMedia>
  )
}

const SocialMedia = styled.div`
  @media (max-width: 350px) {
    font-size: 0.875rem;
  }

  ul {
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 0;
    padding: 0;
    list-style: none;
  }

  li {
    margin: 0 1rem 0 0;
  }

  a {
    color: ${({ theme }) => theme.colors.main};
    text-decoration: none;

    ${linkWorm({ leftOffset: "1.33rem" })}
  }
`

const Icon = styled(FontAwesomeIcon)`
  margin: 0 0.33rem 0 0;
`
